module.exports = __webpack_public_path__ + "static/img/img_logo.e6284e9d.png";